import { useEffect } from "react";

export function openAskbox() {
    if (typeof window === "undefined") return;
    window.Askbox?.open?.();
    window.Askbox?.focus?.();
}

export function useAskbox(options) {
    const instances = Array.isArray(options) ? options : [options];
    const key = instances
        .map(
            (opts) =>
                `${opts?.brain || ""}|${opts?.mode || ""}|${opts?.desktopMount || ""}|${opts?.openDesktop ? "1" : "0"}`
        )
        .join(";");

    useEffect(() => {
        const scripts = instances.map((opts) => {
            const script = document.createElement("script");
            script.src = "/widgets/askbox/askbox.js";
            script.async = true;
            script.dataset.brain = opts.brain;
            script.dataset.mode = opts.mode || (opts.desktopMount ? "embed" : "float");
            if (opts.desktopMount) script.dataset.desktopMount = opts.desktopMount;
            if (opts.openDesktop) script.dataset.openDesktop = "true";
            document.body.appendChild(script);
            return script;
        });

        return () => {
            window.Askbox?.destroy?.();
            scripts.forEach((script) => script.remove());
        };
        // key captures the instance config; instances is rebuilt each render
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [key]);
}
